var module = angular.module('octopusApp.tenants');

module.directive('tenantSummary', function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            tenant: '=',
            projects: '=',
            environments: '='
        },
        templateUrl: 'areas/tenants/views/tenant_summary.html',
        link: function (scope, element) {
        },
        controller: function ($scope) {
            $scope.projectsById = _.object(_.pluck($scope.projects, "Id"), $scope.projects);
            $scope.environmentsById = _.object(_.pluck($scope.environments, "Id"), $scope.environments);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/directives/tenant_summary.js
// module id = 3206083356036114
// module chunks = 1